// A link to an activity that opens it in the activity panel (6.2: docked on the right, or a sheet), over the list you
// are in, instead of leaving it. A new tab or window (Ctrl, Cmd, Shift, middle click) still gets the full page.
import type { MouseEvent, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useActivityDrawer } from '../shell/Dock';

type Extra = { style?: React.CSSProperties; title?: string; 'aria-label'?: string | undefined; role?: string; 'data-kind'?: string };

export function ActLink({ id, className, children, style, title, ...rest }: { id: string; className?: string | undefined; children: ReactNode } & Extra) {
  const drawer = useActivityDrawer();
  const onClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    drawer.open(id);
  };
  return <a href={`/activities/${id}`} className={className} style={style} title={title} onClick={onClick} data-activity={id} {...rest}>{children}</a>;
}

/** Any in-app link: an activity's own address opens it in the panel; anything else (another page, or a tab or a
 *  moment inside an activity) is a plain link. */
export function ToLink({ to, className, children, ...rest }: { to: string; className?: string | undefined; children: ReactNode } & Extra) {
  const m = /^\/activities\/([0-9a-f-]{36})$/.exec(to);
  return m ? <ActLink id={m[1]!} className={className} {...rest}>{children}</ActLink> : <Link className={className} to={to} {...rest}>{children}</Link>;
}
